import React from 'react'; 
const useInfoStyle = React.createContext([{}, () => {}]); 
export default useInfoStyle